import React from 'react';
import './Home.css';

export default function Home() {
  return (
    <div className="home">
      <div className="home-hero">
        <div className="home-hero-image">
          <img src="/images/band-photo.jpg" alt="Echo Hill band photo" />
          <div className="home-hero-gradient" />
        </div>
        <div className="home-hero-content">
          <img src="/images/logo.png" alt="Echo Hill" className="home-logo" />
          <p className="home-tagline">Alternative / Desert / Prog &mdash; Sacramento, CA</p>
        </div>
      </div>
    </div>
  );
}
